import avatarStub from 'images/avatar_thumb_default.png';


class NotificationCardController {
  constructor($sce) {
    'ngInject';

    this.$sce = $sce;
  }

  $onInit() {
    this.sanitizeBody();
  }

  sanitizeBody() {
    this.notification.trustedSubjectText = this.$sce.trustAsHtml(this.notification.subject_text);
  }
}

export default NotificationCardController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/components/notification-card/notification-card.controller.js